export const BASE = "BASE";
export const WINDOW = "WINDOW";
export const LAUNDRY = "LAUNDRY";
export const COMMISSION = "COMMISSION";
export const BASE_DURING_COMMISSION_DAY = "BASE_DURING_COMMISSION_DAY";

export const ACTIVITY_TYPE = [
    {id: BASE, name: "app.activity_type.base"},
    {id: WINDOW, name: "app.activity_type.window"},
    {id: LAUNDRY, name: "app.activity_type.laundry"},
    {id: COMMISSION, name: "app.activity_type.commission"},
    {id: BASE_DURING_COMMISSION_DAY, name: "app.activity_type.baseDuringCommissionDay"},
]

export const activityTypeName = (translate, value) => {
    if (!value) return '';

    const activityType = ACTIVITY_TYPE.find(a => value?.type ? a.id === value.type : a.id === value);
    if (!activityType) return '';

    return translate(activityType.name)
}